import React, { forwardRef } from 'react'
import PhoneNumberInput, { parsePhoneNumber } from 'react-phone-number-input'

import useMarket from 'hooks/useMarket'

import 'react-phone-number-input/style.css'

const PhoneInput = (props, ref) => {
  const { defaultCountry: propDefaultCountry, value } = props
  const market = useMarket()
  const defaultCountry = market.countries?.[0].code || 'test'

  const phoneNumber = value && parsePhoneNumber(value)
  return (
    <PhoneNumberInput
      inputRef={ref}
      {...props}
      defaultCountry={propDefaultCountry || defaultCountry}
      smartCaret={false}
      displayInitialValueAsLocalNumber
      country={phoneNumber?.country}
    />
  )
}

export default forwardRef(PhoneInput)
